<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'sloped-right-rectangle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => {
	if (isCutout) {
		return store.getters.isShapeValid(isCutout) && store.getters.isCutoutGroupValid;
	}

	return store.getters.isShapeValid() && store.getters.isGroupValid;
});

const height = computed({
	get: () => dimensions.value.height,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height",
			value: value,
		});
	},
});

const widthTop = computed({
	get: () => dimensions.value.width_top,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width_top",
			value: value,
		});
	},
});

const widthBottom = computed({
	get: () => dimensions.value.width_bottom,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width_bottom",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="sloped-right-rectangle-height"
			:id="`${prefix}measurements-sloped-right-rectangle-height`"
			:name="`${prefix}measurements[dimensions][height]`"
			unit="cm"
			:label="dimensionLabel('height', 'sloped-right-rectangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('height')"
			:invalid="!isDimensionValid(`${prefix}sloped-right-rectangle-height`)"
			:onBlur="() => addSizeToDataLayer('height', +height, 'sloped-right-rectangle')"
			v-model="height"
		/>

		<dimension-input
			inputRef="sloped-right-rectangle-width_top"
			:id="`${prefix}measurements-sloped-right-rectangle-width_top`"
			:name="`${prefix}measurements[dimensions][width_top]`"
			unit="cm"
			:label="dimensionLabel('width_top', 'sloped-right-rectangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width_top')"
			:invalid="!isDimensionValid(`${prefix}sloped-right-rectangle-width_top`)"
			:onBlur="
				() => addSizeToDataLayer('width_top', +widthTop, 'sloped-right-rectangle')
			"
			v-model="widthTop"
		/>

		<dimension-input
			inputRef="sloped-right-rectangle-width_bottom"
			:id="`${prefix}measurements-sloped-right-rectangle-width_bottom`"
			:name="`${prefix}measurements[dimensions][width_bottom]`"
			unit="cm"
			:label="dimensionLabel('width_bottom', 'sloped-right-rectangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width_bottom')"
			:invalid="!isDimensionValid(`${prefix}sloped-right-rectangle-width_bottom`)"
			:onBlur="
				() => addSizeToDataLayer('width_bottom', +widthBottom, 'sloped-right-rectangle')
			"
			v-model="widthBottom"
		/>
	</shape-input-fields-wrapper>
</template>
